import { CLEAR_ERRORS } from '../constants/actionTypes'

export const clearErrors = () => ({ type: CLEAR_ERRORS })
